import { Checkbox } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { FormField } from '../../../components/FormField'
import { FormModal } from '../../../components/FormModal'
import { FormSelect, SearchableSelect } from '../../../components/Select'
import { useUser } from '../../../contexts/UserContext'
import { useAppToast } from '../../../helpers'
import { ISector, SectorService } from '../../../services/Sector/SectorService'
import { UserService } from '../../../services/User/UserService'
import { IUserGroup, UserGroupService } from '../../../services/UserGroup/UserGroupService'

interface IProps {
  isOpen: boolean
  onClose: () => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  user: any
}

export function UserSetRolesModal({ isOpen, onClose, user }: IProps) {
  const userService = new UserService()
  const userGroupService = new UserGroupService()
  const [userGroups, setUserGroups] = useState<IUserGroup[]>([])
  const sectorService = new SectorService()
  const [sectors, setSectors] = useState<ISector[]>([])
  const [selectedUserGroup, setSelectedUserGroup] = useState<number>(0)
  const [selectedSectors, setSelectedSectors] = useState<number[]>([])
  const [isSenior, setIsSenior] = useState<boolean>(false)
  const toast = useAppToast()
  const { fetchRoles } = useUser()

  useEffect(() => {
    const fetchUserGroups = async () => {
      try {
        await userGroupService.listForSelect().then((data) => {
          setUserGroups(data)
        })
      } catch {
        toast.error(
          'Falha ao carregar grupos de usuários',
          'Ocorreu um erro ao buscar os grupos de usuários. Tente novamente mais tarde.'
        )
        setUserGroups([])
      }
    }
    const fetchSectors = async () => {
      try {
        await sectorService.listForSelect().then((data) => {
          setSectors(data)
        })
      } catch {
        toast.error('Falha ao carregar setores', 'Ocorreu um erro ao buscar os setores. Tente novamente mais tarde.')
        setSectors([])
      }
    }
    fetchUserGroups()
    fetchSectors()
    setSelectedUserGroup(user.user_group_id)
    setSelectedSectors((user.sectors || []).map((sector: ISector) => sector.id))
    setIsSenior(user.is_senior)
  }, [user, isOpen])

  const handleSave = async () => {
    if (selectedUserGroup === 0 || selectedSectors.length === 0) {
      toast.error('Preencha todos os campos')
      return
    }
    await userService.updateRoles(user.id, selectedUserGroup, selectedSectors, isSenior)
    await fetchRoles()
    onClose()
  }

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title={user.name}
      onSubmit={handleSave}
      size="compact"
      isConfirmDisabled={selectedUserGroup === 0}
    >
      <FormField label="Selecione qual o grupo do usuário" mt={4}>
        <FormSelect
          value={selectedUserGroup}
          onChange={(value) => setSelectedUserGroup(Number(value))}
          options={userGroups?.map((userGroup) => ({ value: userGroup.id, label: userGroup.name })) ?? []}
          emptyValue={0}
        />
      </FormField>

      <FormField label="Selecione quais são os setores do usuário" mt={4}>
        <SearchableSelect<number>
          isMulti
          options={sectors.map((s) => ({ value: s.id, label: s.name }))}
          value={selectedSectors ?? []}
          onChange={setSelectedSectors}
          placeholder="Selecione um ou mais setores"
          entity="setor"
        />
      </FormField>
      <Checkbox mt={4} isChecked={isSenior} onChange={(e) => setIsSenior(e.target.checked)}>
        Gestor/sênior
      </Checkbox>
    </FormModal>
  )
}
